import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/vijay-yc.jpg`} alt="" />
      </Link>
      <header>
        <h2>Vijay Chaudhari</h2>
        <p>
          <a href="mailto:mail@vijayyc.com">mail@vijayyc.com</a>
        </p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>
        Hi, I&apos;m Vijay. I am a CS graduate, current working as an Architect
        in Sony India Software Center.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? (
            <Link to="/resume" className="button">
              Learn More
            </Link>
          ) : (
            <Link to="/about" className="button">
              About Me
            </Link>
          )}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">
        &copy; Vijay Chaudhari <Link to="/">vijayyc.com</Link>.
      </p>
    </section>
  </section>
);

export default SideBar;
